import React, {Component} from 'react'
import {bindActionCreators, compose} from 'redux'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {login, signUp, logout, loginWithoutModal} from '../../actions/gigya'
import Symbol from './../Symbol'
import getMenuStructure from './menuStructure'
import SiteMenuMobile from './components/SiteMenuMobile'
import UserMenuMobile from './components/UserMenuMobile'
import HeaderMenuDesktop from './components/HeaderMenuDesktop'
import MessengerPopUp from './components/MessengerPopUp'
import UserMenuLinks from '../../utils/UserMenuLinks'
import {Wrapper, SubHeader, Left, Right, RightMobile, RightDesktop} from './components/Styled'
import RenderAt from '../RenderAt'
import {withGigya} from '../../utils/gigya'

class Header extends Component {
  static defaultProps = {
    isHidden: true,
    isLogged: false,
    showProfileMenu: false,
    user: null
  }

  static propTypes = {
    accountLinks: PropTypes.object,
    cms: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    haveUnreadMessages: PropTypes.bool,
    isHidden: PropTypes.bool.isRequired,
    isLogged: PropTypes.bool.isRequired,
    isSuperUser: PropTypes.bool,
    lastMessage: PropTypes.object,
    login: PropTypes.func.isRequired,
    loginWithoutModal: PropTypes.func,
    logout: PropTypes.func.isRequired,
    messengerLink: PropTypes.string,
    pageLinkHeader: PropTypes.string,
    showProfileMenu: PropTypes.bool,
    signUp: PropTypes.func.isRequired,
    socialData: PropTypes.object,
    unreadMessageCount: PropTypes.number,
    user: PropTypes.object,
    userIsBreeder: PropTypes.bool,
    userIsGroomer: PropTypes.bool,
    userIsTrainer: PropTypes.bool
  }

  constructor (props) {
    super(props)

    this.state = {
      isHidden: this.props.isHidden,
      showProfileMenu: this.props.showProfileMenu,
      tabOpen: null,
      subTabOpen: null
    }

    if (window.location.hash === '#log-in' && !this.props.isLogged) {
      this.props.login()
    }
  }

  componentDidMount () {
    // Check there is a user logged in Gigya.
    // window.gigya.accounts.verifyLogin({
    //   callback: async response => {
    //     if (response.errorCode > 0 && this.props.isLogged) {
    //       this.props.logout()
    //       return false
    //     }

    //     if (response.errorCode === 0 && !this.props.isLogged) {
    //       this.props.loginWithoutModal(response)
    //     }
    //   }
    // })
    window.gigya.accounts.addEventHandlers({
      onLogin: response => this.props.loginWithoutModal(response),
      onLogout: () => this.props.logout(false, true)
    })
  }

  getLogoLink () {
    if (this.props.pageLinkHeader) {
      return this.props.pageLinkHeader
    }

    return '/'
  }

  handleShowProfileMenu = () => {
    this.setState({showProfileMenu: true})
    clearTimeout(this.hideProfileMenuTimeout)
  }

  handleHideProfileMenu = () => {
    this.hideProfileMenuTimeout = setTimeout(() => {
      this.setState({showProfileMenu: false})
    }, 250)
  }

  renderMenuLink (menuLink) {
    let optionalProps = {}
    if (menuLink.onClick) {
      optionalProps.onClick = menuLink.onClick
    }
    return (
      <li key={menuLink.title} className='edit-menu__options-item' {...optionalProps}>
        {menuLink.unread && <span className='' />}
        <a href={menuLink.url || '#'}>{menuLink.title}</a>
        {this.props.unreadMessageCount && menuLink.title.toLowerCase() === 'messenger' ? <span className='header-unread-count__menu' >{this.props.unreadMessageCount}</span> : '' }
      </li>
    )
  }

  getUserProfileLinks () {
    let menuLinks = new UserMenuLinks(this.props.accountLinks, () => this.props.logout(this.props.isSuperUser), this.props.haveUnreadMessages, this.props.messengerLink, this.props.userIsBreeder, this.props.userIsGroomer, this.props.userIsTrainer).getUserMenu()
    return (
      <ul className='edit-menu__options'>
        {
          menuLinks.map(menuLink => {
            return this.renderMenuLink(menuLink)
          })
        }
      </ul>
    )
  }

  render () {
    return (
      <React.Fragment>
        <Wrapper>
          <Left>
            <a href={this.getLogoLink()}>
              <Symbol className='icon icon-mp-logo' name='desktop-blue-redesign' />
            </a>
          </Left>
          <Right>
            <RenderAt fragment mobile tablet>
              <RightMobile>
                <UserMenuMobile unreadMessageCount={this.props.unreadMessageCount} onLogin={() => this.props.login()} onLogout={() => this.props.logout(this.props.isSuperUser)} />
                <SiteMenuMobile closeIcon='icon-close' icon='icon-menu' menus={getMenuStructure()} title='MENU' />
              </RightMobile>
            </RenderAt>
            <RenderAt desktop fragment laptop>
              <RightDesktop>
                <div className='header-bar'>
                  <div className='header-icon-container user-menu'
                    onClick={this.handleShowProfileMenu}
                    onMouseEnter={this.handleShowProfileMenu}
                    onMouseLeave={this.handleHideProfileMenu}>
                    {this.props.isLogged
                      ? <div>
                        <a href='#'>
                          <Symbol className='icon' height='15' name='icon-akc-user' width='15' />
                          <span> {this.props.user.name} {this.props.unreadMessageCount ? <span className='header-unread-count' > {this.props.unreadMessageCount} </span> : '' } </span>
                          { window.marketplace.state.app.environment === 'local' && <span><br/>{this.props.user.email}</span> }
                        </a>
                        <div className='edit-menu__wrap'>
                          <div className='edit-menu' style={{display: this.state.showProfileMenu ? 'block' : 'none', width: '172px', top: '8px'}}>
                            {this.getUserProfileLinks()}
                          </div>
                        </div>
                      </div>
                      : <a onClick={() => this.props.login()}>
                        <Symbol className='icon' height='15' name='icon-akc-user' width='15' />
                        <span dusk='sign_in_link'>Sign in</span>
                      </a>
                    }
                  </div>
                  <div className='header-icon-container'>
                    <a href='https://shop.akc.org' rel='noopener noreferrer' target='_blank'>
                      <Symbol className='icon' height='15' name='icon-cart' width='15' />
                      <span>Shop</span>
                    </a>
                  </div>
                  <div className='header-icon-container'>
                    <a href='https://www.akc.org' rel='noopener noreferrer' target='_blank'>
                      <Symbol className='icon' height='15' name='icon-akc-home' width='15' />
                      <span>AKC.org</span>
                    </a>
                  </div>
                  {this.props.lastMessage &&
                    <MessengerPopUp
                      messageObject={this.props.lastMessage}
                      redirectTo={this.props.accountLinks.messenger}
                    />
                  }
                </div>
                <HeaderMenuDesktop/>
              </RightDesktop>
            </RenderAt>
          </Right>
        </Wrapper>
        <SubHeader />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  page: state.app.page,
  pageLinkHeader: state.app.page_link_header,
  cms: state.app.cms,
  header: state.header,
  isLogged: state.app.isLogged,
  user: state.app.user,
  haveUnreadMessages: state.app.have_unread_messages,
  lastMessage: state.app.lastMessage ? state.app.lastMessage : null,
  messengerLink: state.app.messenger_link,
  accountLinks: state.app.account_links,
  userIsBreeder: state.app.user_is_breeder,
  userIsTrainer: state.app.user_is_trainer,
  userIsGroomer: state.app.user_is_groomer,
  socialData: state.app.social_data,
  isSuperUser: state.app.isSuperUser,
  unreadMessageCount: state.app.unreadMessageCount
})

const mapDispatchToProps = dispatch => bindActionCreators({login, signUp, loginWithoutModal, logout}, dispatch)

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withGigya
)(Header)
